import focusWithin from 'focus-within';
import FeaturedPostSlider from './modules/featured-post-slider';
import SuperheroSlider from './modules/superhero';
import MediaSlider from './modules/media-slider';
import TeamSlider from './modules/team-slider';
import Ticker from './modules/ticker';
import IconGridSlider from './modules/icon-grid-slider';
import CardsSlider from './modules/cards-slider';
import initTeamGrid from './modules/team-grid';
import TestimonialSlider from './modules/testimonials-slider';
import accordionAutomaticInit from './modules/accordion';
import TabsAutomatic from './modules/accessibilityTabs';
import initVideoCarouselModal from './modules/video-carousel-modal';
import initVideoCarouselSlider from './modules/video-carousel-slider';
import initDefeatTheMonstersGame from './modules/defeat-the-monsters-game';
import initCanYouMatchTheSymptoms from './modules/can-you-match-the-symptoms';
import initCreateCrewName from './modules/create-crew-name';
import initInteractiveHouse from './modules/interactive-house';
import initFlipManager from './modules/flipManager';
import hideSeek from "./modules/hide-seek";
import postFilters from "./modules/postFilters"
import initHubSpotForm from './modules/hubspot';
import timeline from './timeline';

import {
    watchScroll,
    hasLightNext, teamSliderBioToggle,
    activePostsGrid, caseStudyAnimations,
    togglePostContent, updateActiveNav,
    copyLink, mobileNavToggle, monitorSectionsInViewport, setCookie
} from './modules/helpers';

jQuery(document).ready(function ($) {
    // Remove no-js class and replace with js.
    $('html').addClass('js').removeClass('no-js');
    window.setCookie = setCookie;


    // :focus-within polyfill
    focusWithin(document);
    watchScroll();

    FeaturedPostSlider().init();
    initVideoCarouselSlider();
    initVideoCarouselModal();
    initDefeatTheMonstersGame();
    initCanYouMatchTheSymptoms();
    initCreateCrewName();
    initInteractiveHouse();
    accordionAutomaticInit();
    TabsAutomatic();
    //SuperheroSlider().init();
    //MediaSlider().init();
    //TeamSlider().init();
    TestimonialSlider().init();
    //Ticker().init();
    //IconGridSlider().init();
    //CardsSlider().init();
    //hideSeek().init();
    //initTeamGrid();
    //initFlipManager();
    timeline();

    //adhoc JS
    hasLightNext();
    //teamSliderBioToggle();
    //activePostsGrid();
    //togglePostContent();
    //copyLink();
    mobileNavToggle();
    monitorSectionsInViewport();
    //caseStudyAnimations();
    //updateActiveNav();

    //postFilters($);

    //todo: evaluate this block and remove duplication of above
});
